import React, { useState } from 'react';

const Analytics = () => {
  const [timeRange, setTimeRange] = useState('7d');
  
  const performanceData = [
    { name: 'Mon', workflows: 45, agents: 32, success: 98 },
    { name: 'Tue', workflows: 52, agents: 38, success: 96 },
    { name: 'Wed', workflows: 48, agents: 35, success: 99 },
    { name: 'Thu', workflows: 61, agents: 42, success: 97 },
    { name: 'Fri', workflows: 55, agents: 39, success: 98 },
    { name: 'Sat', workflows: 38, agents: 28, success: 99 },
    { name: 'Sun', workflows: 42, agents: 31, success: 97 }
  ];

  const topAgents = [
    { name: 'Support-Bot-01', requests: 15420, successRate: 98.5, avgTime: '1.2s' },
    { name: 'Security-Guard', requests: 22100, successRate: 96.8, avgTime: '0.5s' },
    { name: 'Marketing-Flow', requests: 8930, successRate: 94.2, avgTime: '2.1s' },
    { name: 'Data-Sync-Agent', requests: 3456, successRate: 99.1, avgTime: '0.8s' }
  ];

  const workflowMetrics = [
    { name: 'Customer Support Automation', executions: 1247, successRate: 98.5, avgDuration: '45s' },
    { name: 'Lead Qualification Pipeline', executions: 892, successRate: 94.2, avgDuration: '2m 15s' },
    { name: 'Invoice Processing', executions: 567, successRate: 96.8, avgDuration: '1m 30s' },
    { name: 'Data Sync & Validation', executions: 2156, successRate: 99.1, avgDuration: '30s' }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-black text-white tracking-tight">Analytics</h2>
          <p className="text-[#92b7c9] mt-1">Monitor performance and insights across your AI infrastructure.</p>
        </div>
        <div className="flex items-center gap-3">
          <select 
            value={timeRange} 
            onChange={(e) => setTimeRange(e.target.value)}
            className="bg-slate-100 dark:bg-[#233c48] border-none rounded-lg px-4 py-2 text-sm focus:ring-1 focus:ring-primary text-white"
          >
            <option value="24h">Last 24 Hours</option>
            <option value="7d">Last 7 Days</option>
            <option value="30d">Last 30 Days</option>
            <option value="90d">Last 90 Days</option>
          </select>
          <button className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg font-semibold flex items-center gap-2 transition-colors">
            <span className="material-symbols-outlined text-sm">download</span>
            Export Report
          </button>
        </div>
      </div>

      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-primary/10 rounded-lg">
              <span className="material-symbols-outlined text-primary">trending_up</span>
            </div>
            <span className="text-xs text-emerald-500 font-bold">+12.5%</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Total Executions</p>
          <h3 className="text-white text-2xl font-bold mt-1">49.2K</h3>
          <p className="text-xs text-slate-400 mt-1">vs last period</p>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-emerald-500/10 rounded-lg">
              <span className="material-symbols-outlined text-emerald-500">check_circle</span>
            </div>
            <span className="text-xs text-emerald-500 font-bold">+0.3%</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Success Rate</p>
          <h3 className="text-white text-2xl font-bold mt-1">97.2%</h3>
          <p className="text-xs text-slate-400 mt-1">vs last period</p>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <span className="material-symbols-outlined text-blue-500">speed</span>
            </div>
            <span className="text-xs text-blue-500 font-bold">-0.2s</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Avg Response Time</p>
          <h3 className="text-white text-2xl font-bold mt-1">1.4s</h3>
          <p className="text-xs text-slate-400 mt-1">vs last period</p>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-purple-500/10 rounded-lg">
              <span className="material-symbols-outlined text-purple-500">savings</span>
            </div>
            <span className="text-xs text-purple-500 font-bold">$2.4K saved</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Cost Efficiency</p>
          <h3 className="text-white text-2xl font-bold mt-1">$8.2K</h3>
          <p className="text-xs text-slate-400 mt-1">total savings</p>
        </div>
      </div>

      {/* Performance Chart */}
      <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#233c48] rounded-xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-white font-bold text-lg">Performance Overview</h3>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-primary"></div>
              <span className="text-xs text-slate-400">Workflows</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
              <span className="text-xs text-slate-400">AI Agents</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-blue-500"></div>
              <span className="text-xs text-slate-400">Success Rate</span>
            </div>
          </div>
        </div>
        
        {/* Simple Bar Chart Representation */}
        <div className="space-y-4">
          {performanceData.map((day, index) => (
            <div key={index} className="flex items-center gap-4">
              <div className="w-12 text-xs text-slate-400 font-medium">{day.name}</div>
              <div className="flex-1 flex items-center gap-2">
                <div className="flex-1 bg-slate-200 dark:bg-[#233c48] h-2 rounded-full overflow-hidden">
                  <div 
                    className="bg-primary h-full rounded-full transition-all duration-500" 
                    style={{width: `${(day.workflows / 70) * 100}%`}}
                  ></div>
                </div>
                <div className="flex-1 bg-slate-200 dark:bg-[#233c48] h-2 rounded-full overflow-hidden">
                  <div 
                    className="bg-emerald-500 h-full rounded-full transition-all duration-500" 
                    style={{width: `${(day.agents / 50) * 100}%`}}
                  ></div>
                </div>
                <div className="flex-1 bg-slate-200 dark:bg-[#233c48] h-2 rounded-full overflow-hidden">
                  <div 
                    className="bg-blue-500 h-full rounded-full transition-all duration-500" 
                    style={{width: `${day.success}%`}}
                  ></div>
                </div>
              </div>
              <div className="flex gap-4 text-xs font-semibold">
                <span className="text-primary w-8">{day.workflows}</span>
                <span className="text-emerald-500 w-8">{day.agents}</span>
                <span className="text-blue-500 w-8">{day.success}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Top Performers */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Top AI Agents */}
        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#233c48] rounded-xl overflow-hidden">
          <div className="p-6 border-b border-slate-200 dark:border-[#233c48]">
            <h3 className="text-white font-bold text-lg flex items-center gap-2">
              <span className="material-symbols-outlined text-primary">smart_toy</span>
              Top Performing Agents
            </h3>
          </div>
          <div className="p-0">
            {topAgents.map((agent, index) => (
              <div key={index} className="p-4 border-b border-slate-100 dark:border-[#233c48] last:border-b-0 hover:bg-slate-50 dark:hover:bg-[#1a2b35] transition-colors">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="text-white font-semibold text-sm">{agent.name}</h4>
                  <span className="text-xs text-slate-400">#{index + 1}</span>
                </div>
                <div className="grid grid-cols-3 gap-4 text-xs">
                  <div>
                    <p className="text-slate-400">Requests</p>
                    <p className="text-white font-bold">{agent.requests.toLocaleString()}</p>
                  </div>
                  <div>
                    <p className="text-slate-400">Success Rate</p>
                    <p className="text-emerald-500 font-bold">{agent.successRate}%</p>
                  </div>
                  <div>
                    <p className="text-slate-400">Avg Time</p>
                    <p className="text-blue-500 font-bold">{agent.avgTime}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Top Workflows */}
        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#233c48] rounded-xl overflow-hidden">
          <div className="p-6 border-b border-slate-200 dark:border-[#233c48]">
            <h3 className="text-white font-bold text-lg flex items-center gap-2">
              <span className="material-symbols-outlined text-primary">account_tree</span>
              Top Performing Workflows
            </h3>
          </div>
          <div className="p-0">
            {workflowMetrics.map((workflow, index) => (
              <div key={index} className="p-4 border-b border-slate-100 dark:border-[#233c48] last:border-b-0 hover:bg-slate-50 dark:hover:bg-[#1a2b35] transition-colors">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="text-white font-semibold text-sm">{workflow.name}</h4>
                  <span className="text-xs text-slate-400">#{index + 1}</span>
                </div>
                <div className="grid grid-cols-3 gap-4 text-xs">
                  <div>
                    <p className="text-slate-400">Executions</p>
                    <p className="text-white font-bold">{workflow.executions.toLocaleString()}</p>
                  </div>
                  <div>
                    <p className="text-slate-400">Success Rate</p>
                    <p className="text-emerald-500 font-bold">{workflow.successRate}%</p>
                  </div>
                  <div>
                    <p className="text-slate-400">Avg Duration</p>
                    <p className="text-blue-500 font-bold">{workflow.avgDuration}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Resource Usage */}
      <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#233c48] rounded-xl p-6">
        <h3 className="text-white font-bold text-lg mb-6 flex items-center gap-2">
          <span className="material-symbols-outlined text-primary">memory</span>
          Resource Usage
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-slate-400">CPU Usage</span>
              <span className="text-white font-bold">42%</span>
            </div>
            <div className="w-full bg-slate-200 dark:bg-[#233c48] h-2 rounded-full overflow-hidden">
              <div className="bg-primary h-full rounded-full transition-all duration-500" style={{width: '42%'}}></div>
            </div>
          </div>
          
          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-slate-400">Memory Usage</span>
              <span className="text-white font-bold">68%</span>
            </div>
            <div className="w-full bg-slate-200 dark:bg-[#233c48] h-2 rounded-full overflow-hidden">
              <div className="bg-emerald-500 h-full rounded-full transition-all duration-500" style={{width: '68%'}}></div>
            </div>
          </div>
          
          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-slate-400">Storage Usage</span>
              <span className="text-white font-bold">34%</span>
            </div>
            <div className="w-full bg-slate-200 dark:bg-[#233c48] h-2 rounded-full overflow-hidden">
              <div className="bg-blue-500 h-full rounded-full transition-all duration-500" style={{width: '34%'}}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;